import a from "react";
import { TypographyComponent as p } from "../typography/typography-component.esm.js";
import "../typography/typography-config.esm.js";
import { ScreenReaderOnly as m } from "../utils/sr-only.esm.js";
import { ratingCssConfig as n } from "./config.esm.js";
import { s as i } from "../rating.module-BNUHsKEH.mjs";
const s = (r) => {
  const t = {};
  return Object.keys(r).forEach((e) => {
    const o = r[e];
    o && (t[e] = n[o].fontSize);
  }), t;
}, g = (r) => typeof r == "string" ? n[r].fontSize : s(r), f = ({ size: r = "large", rating: t = 0 }) => /* @__PURE__ */ a.createElement(
  p,
  {
    className: i.rating__number,
    type: "paragraph",
    size: g(r)
  },
  "(",
  t,
  ")",
  /* @__PURE__ */ a.createElement(m, null, " out of 5 stars")
);
f.displayName = "RatingNumber";
export {
  f as RatingNumber
};
